<template>
  <div>
    <Head title="Nueva Empresa de Transporte" />

    <div class="max-w-2xl mx-auto">
      <div class="flex items-center gap-3 mb-6">
        <Link href="/carriers" class="w-10 h-10 bg-white border border-gray-200 rounded-lg flex items-center justify-center text-gray-500 hover:bg-gray-50 transition-colors shadow-sm">
          <i class="fa fa-arrow-left" />
        </Link>
        <div>
          <h1 class="text-3xl font-bold text-gray-800">Nuevo Transportista</h1>
          <p class="text-gray-500 text-sm">Registra una nueva empresa o conductor independiente.</p>
        </div>
      </div>

      <div class="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
        <form class="space-y-5" @submit.prevent="submit">
          <!-- Nombre -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Nombre / Razón Social <span class="text-red-500">*</span></label>
            <input 
              v-model="form.name" 
              type="text" 
              required
              class="w-full bg-white border border-gray-200 rounded-lg px-4 py-2.5 focus:ring-orange-500 focus:border-orange-500 transition-colors"
              placeholder="Ej: Fletamos App"
            />
            <p v-if="form.errors.name" class="text-red-500 text-xs mt-1">{{ form.errors.name }}</p>
          </div>

          <!-- RIF / Documento -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">RIF / Documento</label>
            <input 
              v-model="form.document_number" 
              type="text" 
              class="w-full bg-white border border-gray-200 rounded-lg px-4 py-2.5 focus:ring-orange-500 focus:border-orange-500 transition-colors"
              placeholder="Ej: J-123456789"
            />
          </div>

          <div class="grid grid-cols-1 sm:grid-cols-2 gap-5">
            <!-- Teléfono -->
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">Teléfono</label>
              <input 
                v-model="form.contact_phone" 
                type="text" 
                class="w-full bg-white border border-gray-200 rounded-lg px-4 py-2.5 focus:ring-orange-500 focus:border-orange-500 transition-colors"
                placeholder="Ej: 0414-1234567"
              />
            </div>
            
            <!-- Email -->
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">Correo Electrónico</label>
              <input 
                v-model="form.contact_email" 
                type="email" 
                class="w-full bg-white border border-gray-200 rounded-lg px-4 py-2.5 focus:ring-orange-500 focus:border-orange-500 transition-colors"
                placeholder="correo@empresa.com"
              />
            </div>
          </div>

          <div class="pt-4 border-t border-gray-100 flex justify-end gap-3">
            <Link href="/carriers" class="px-6 py-2.5 border border-gray-200 text-gray-700 rounded-lg hover:bg-gray-50 font-medium transition-colors">
              Cancelar
            </Link>
            <button 
              type="submit" 
              :disabled="form.processing"
              class="px-6 py-2.5 bg-orange-500 hover:bg-orange-600 disabled:opacity-50 text-white rounded-lg font-bold shadow-sm transition-colors"
            >
              Guardar Transportista
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

export default {
  components: { Head, Link },
  layout: Layout,
  data() {
    return {
      form: this.$inertia.form({
        name: '',
        document_number: '',
        contact_phone: '',
        contact_email: '',
      }),
    }
  },
  methods: {
    submit() {
      this.form.post('/carriers')
    },
  },
}
</script>
